module.exports = __webpack_public_path__ + "static/media/company-scene.1de2abd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/company-scene.jpg
// module id = 147
// module chunks = 6